// @ts-nocheck
import React, { useState } from "react";
import ProcessedModelTable from "./ProcessedModelTable";
import ProcessedModelModal from "./ProcessedModelModal";
import { ProcessedModelRecord, Asset, AssetGroup } from "./utils";

interface ProcessedModelManagementProps {
  assets: Asset[];
  assetGroup: AssetGroup;
}

const ProcessedModelManagement: React.FC<ProcessedModelManagementProps> = ({
  assets,
  assetGroup,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingModel, setEditingModel] = useState<ProcessedModelRecord | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAddNew = () => {
    setEditingModel(null);
    setIsModalOpen(true);
  };

  const handleEdit = (model: ProcessedModelRecord) => {
    setEditingModel(model);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditingModel(null);
  };

  const handleModalSave = () => {
    // Refresh the table by updating the key
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      {/* Main Management Panel */}
      <div className="h-full overflow-y-auto">
        <ProcessedModelTable
          key={refreshKey}
          assets={assets}
          assetGroup={assetGroup}
          onAddNew={handleAddNew}
          onEdit={handleEdit}
        />
      </div>

      {/* Modal for Add/Edit */}
      <ProcessedModelModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSave={handleModalSave}
        assets={assets}
        assetGroup={assetGroup}
        editingModel={editingModel}
      />
    </>
  );
};

export default ProcessedModelManagement;
